export default {
    isRoleFormOpen: state => state.roleFormIsOpen,
    isRoleGridOpen: state => state.roleGridIsOpen,
    getRoleHeaderFields: state => state.roleHeaderFields,
    getRoleFormActions: state => state.roleFormActions,
    getRoleActions: state => state.roleActions,
    getRoleRowActions: state => state.roleRowActions,

    isPermissionFormOpen: state => state.permissionFormIsOpen,
    isPermissionGridOpen: state => state.permissionGridIsOpen,
    getPermissionHeaderFields: state => state.permissionHeaderFields,
    getPermissionFormActions: state => state.permissionFormActions,
    getPermissionActions: state => state.permissionActions,
    getPermissionRowActions: state => state.permissionRowActions,
}
